import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import React from "react"
import { NovaSpinner } from "../../component-nova-spinner/src/nova-spinner"

const iconClasses = "rounded-md cursor-pointer"

type ConfirmControlsProps = {
    isValid: boolean

    /** Use this to control a loading state while the confirm action is happening. */
    isConfirming?: boolean

    iconClassName?: string

    onConfirm: () => void
    onCancel: () => void
    onReset?: () => void
}

export const ConfirmControls = ({
    isValid,
    isConfirming,
    iconClassName,
    onConfirm,
    onCancel,
    onReset,
}: ConfirmControlsProps) => {
    return (
        <div className="flex gap-1">
            {!isConfirming ? (
                <>
                    <Icons.SmallIcon
                        Icon={Icons.Checkmark}
                        className={classNames(iconClasses, iconClassName, {
                            "text-green-500": isValid,
                            "text-gray-400": !isValid,
                        })}
                        onClick={
                            isValid
                                ? (e) => {
                                      e.stopPropagation()
                                      onConfirm()
                                  }
                                : undefined
                        }
                    />
                    {onReset && (
                        <Icons.SmallIcon
                            Icon={Icons.Refresh}
                            className={classNames(
                                iconClasses,
                                iconClassName,
                                "text-gray-400 hover:text-gray-100"
                            )}
                            onClick={(e) => {
                                e.stopPropagation()
                                onReset?.()
                            }}
                        />
                    )}
                    <Icons.SmallIcon
                        Icon={Icons.XClose}
                        className={classNames(
                            iconClasses,
                            iconClassName,
                            "text-gray-400 hover:text-red-500"
                        )}
                        onClick={(e) => {
                            e.stopPropagation()
                            onCancel()
                        }}
                    />
                </>
            ) : (
                <div className="w-5 h-5 flex items-center justify-center">
                    <NovaSpinner width={16} height={16} />
                </div>
            )}
        </div>
    )
}
